<template>
    <Teleport to="body">
        <div id="drawer-modal"
             class="bg-body drawer drawer-end"
             data-kt-drawer="true"
             data-kt-drawer-name="app-settings"
             data-kt-drawer-activate="true"
             :data-kt-drawer-overlay="showOverlay"
             :data-kt-drawer-width="{default: width +'px'}"
             data-kt-drawer-direction="end"
             data-kt-drawer-toggle="#kt_app_layout_builder_toggle"
             data-kt-drawer-close="#kt_app_layout_builder_close" :style="`z-index:${zIndex}`">
            <!--begin::Card-->
            <div class="card shadow-none rounded-0 w-100" :id="id">
                <!--begin::Header-->
                <div class="card-header" id="kt_help_header" v-if="showHeader">
                    <h2 class="card-title fw-semibold fs-1  fw-bold">
                        {{title}}
                    </h2>

                    <div class="card-toolbar">
                        <button type="button" @click="close()"
                               class="btn btn-bg-light  btn-sm">
                            <KTIcon icon-name="cross" icon-class="fs-1" class="p-0"/>
                        </button>
                    </div>
                </div>
                <!--end::Header-->
                <!--begin::Body-->
                <div class="card-body hover-scroll-overlay-y" :class="{'p-0': !showHeader, 'fix-height': fixHeight}">
                    <slot></slot>
                </div>
                <!--end::Body-->
                <div class="card-footer" style="padding: 10px;" v-if="showFooter">
                    <slot name="footer"> </slot>
                </div>
            </div>
            <!--end::Card-->
        </div>
    </Teleport>
</template>

<script setup>
    import { DrawerComponent } from 'assets/ts/components';
    import { defineProps, defineEmits, ref } from "vue";
    import { onClickOutside } from "@vueuse/core";

    const props = defineProps({
        autoClose: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: "Thông tin",
        },
        width: {
            type: Number,
            required: false,
            default: 800,
        },
        id: {
            type: String,
            required: false,
            default: "",
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
        showFooter: {
            type: Boolean,
            default: true,
        },
        showOverlay: {
            type: Boolean,
            default: true,
        },
        fixHeight: {
            type: Boolean,
            default: true,
        }
    });
    var drawer
    const idReal = props.id || "common_modal_" + new Date().getTime();
    const emit = defineEmits(["close"]);
    const cls = ref("");
    const zIndex = 1050 + 10 * document.querySelectorAll(".modal").length;
    onMounted(() => {
        let body = document.querySelector("body");
        body.classList.add("modal-open");
        body.style.overflow = "hidden";
        drawer = new DrawerComponent(document.getElementById("drawer-modal"))
        drawer.toggle();
        if (props.autoClose && props.showOverlay) {
            document.querySelector('.drawer-overlay').addEventListener("click", function (evt) {
                close()
            });
        }
    });
    onUnmounted(() => {
        let body = document.querySelector("body");
        body.classList.remove("modal-open");
        body.style.overflow = "auto";
        close()
    });
    const target = ref(null);
    onClickOutside(target, () => emit("close"));

    function close() {
        drawer.hide()
        setTimeout(() => {
            emit("close")
        }, 500)
    }
</script>
